import { Consumer } from '@rails/actioncable';
import { useState, useEffect } from 'react';

export type Bonus = {
  amount: number | null;
  status: string | null;
};

const useBonus = (amount: Bonus['amount'], status: Bonus['status']): Bonus => {
  const [bonus, setBonus] = useState<Bonus>({ amount, status });

  useEffect(() => {
    const cable = window.cable as Consumer;
    const subscription = cable.subscriptions.create(
      {
        channel: 'FreebetBonusesChannel',
      },
      {
        received: setBonus,
      }
    );

    return () => {
      subscription.unsubscribe();
    };
  }, []);

  return bonus;
};

export default useBonus;
